export default "<div class=\"history-graph\" id=\"svg\" #graph>\r\n</div>"